import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja';
import relativeTime from 'dayjs/plugin/relativeTime.js'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
    dayjs.extend(relativeTime)
    dayjs.locale(ja)
    return {
        provide: {
            dayjs:dayjs
        }
    }
})
